import { initStore } from "./store";

const configureStore = () => {
  const actions = {
    SET_SERVERPROCESSING: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          serverProcessing: payload, 
        }
      };
    },
    SET_ISUSERRUNNING: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          isUserRunning: payload, 
        }
      };
    },
    SET_SHOWIMAGEUPLOAD: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          showUploadImage: payload, 
        }
      };
    },
    SET_SHOWABOUTIOPAINT: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          showAboutIopaint: payload, 
        }
      };
    },
    SET_SHOWINPAINTSETTINGS: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          showInpaintSettings: payload, 
        }
      };
    },
    SET_SHOWINPAINTFILES: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          showInpaintFiles: payload, 
        }
      };
    },
    SET_SHOWSTYLECHANGESETTINGS: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          showStyleChangeSettings: payload, 
        }
      };
    },
    SET_CURRENTINPAINTFILE: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          currentInpaintFile: payload, 
        }
      };
    },
    SET_IPADAPTERIMAGE: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          ipAdapterImage: payload, 
        }
      };
    },
    SET_IPADAPTERSCALE: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          ipAdapterScale: payload, 
        }
      };
    },
    SET_MODELNAME: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          modelName: payload, 
        }
      };
    },
    SET_IPADAPTERIMAGES: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          ipAdapterImages: payload, 
        }
      };
    },
    SET_INPUTETA: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          inputEta: payload, 
        }
      };
    },
    SET_APPNAME: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          appName: payload, 
        }
      };
    },
    SET_STYLECHANGEGUIDANCE: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          styleChangeGuidance: payload, 
        }
      };
    },
    SET_USEIPAALL: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          useIpaAll: payload, 
        }
      };
    },
    SET_ISIOPAINTSERVEREXIST: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          isIopaintServerExist: payload, 
        }
      };
    },
    SET_LOADEDFILES: (state, payload) => {
      return { 
        iopaintStore : {
          ...state.iopaintStore,
          loadedFiles: payload, 
        }
      };
    },
    // SET_INVALIDFILE: (state, payload) => {
    //   return { 
    //     iopaintStore : {
    //       ...state.iopaintStore,
    //       invalidFile: payload, 
    //     }
    //   };
    // },
    // SET_RESETSETTINGS: (state, payload) => {
    //   return { 
    //     iopaintStore : {
    //       ...state.iopaintStore,
    //       resetSettings: payload, 
    //     }
    //   };
    // },
  };

  initStore(actions, {
    iopaintStore: {
      serverProcessing: false,
      isUserRunning: false,
      showUploadImage: false,
      showAboutIopaint: false,
      showInpaintSettings: false,
      showInpaintFiles: false,
      showStyleChangeSettings: false,
      currentInpaintFile: null,
      ipAdapterImage: null,
      ipAdapterScale: 0.7,
      modelName: '',
      ipAdapterImages: [],
      inputEta: 0.8,
      appName: 'inpaint-bkv2',
      styleChangeGuidance: 6.0,
      useIpaAll: false,
      isIopaintServerExist: false,
      // invalidFile: false,
      // resetSettings: false,
      loadedFiles: null,
    }
  });
};

export default configureStore;
